import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import { IFeedEntry } from "../../store/FeedEntry";

interface IEmbedCardProps {
  feedEntry: IFeedEntry;
}

function EmbedCard({
  feedEntry,
}: IEmbedCardProps) {
  console.log("EmbedCard");

  return (
    <div style={{
          position: "relative",
          paddingBottom: "56.25%",
          paddingTop: "25px",
          height: 0,
    }}>
      <iframe
        src={feedEntry.video}
        title={feedEntry.title}
        width="100%"
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
        }}
        // webkitallowfullscreen="true"
        // mozallowfullscreen="true"
        allowFullScreen
      ></iframe>
      </div>
  );
}

export default EmbedCard;
 // max-md:fixed max-md:h-5/6
// max-md:fixed max-md:h-1/5 bottom-0